export default __webpack_public_path__ + "static/media/supplier-illustration.a9c73ec2.png";